import React, { useEffect, useState } from 'react';
import { useAppSelector } from 'hooks/redux';
import { useNavigate } from 'react-router-dom';
import { selectCurrentStaffUser } from 'store/slices/staff-user/staff-user-slice';

interface Props {
    children?: React.ReactNode;
}

export const Authorized = (props: Props) => {
    const { children } = props;
    const currentStaffUser = useAppSelector(selectCurrentStaffUser);

    const [signedIn, setSignedIn] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (!currentStaffUser) {
            navigate('/');
        }

        setSignedIn(!!currentStaffUser);
    }, [currentStaffUser]);

    return <>{signedIn && children}</>;
};
